import { Col, Row } from "react-bootstrap";

interface VerticalLayoutProps {
  className?: string;
  children: React.ReactNode[];
}

const VerticalLayout: React.FC<VerticalLayoutProps> = ({
  className,
  children,
}) => {
  return (
    <Row className={className ? className : " pt-2"}>
      {children.map(
        (item, idx) =>
          item && (
            <Col xs="12" className="mb-3" key={idx}>
              {item}
            </Col>
          )
      )}
    </Row>
  );
};

export default VerticalLayout;
